/* SLIDE 39 */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import SubHeader from "shared/components/SubHeader";
import { useSelector, useDispatch } from "react-redux";
import { getParkingStatistics } from "features/parking/usecases/ParkingUsecases";
import { numberFormat } from "utils/common";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { setAppLoading } from "../../../shared/store/headerSlice";
import AppInfiniteScroll from "../../../shared/components/AppInfiniteScroll";
import { DateTime } from "luxon";
import { getFormattedTime } from "../../../utils/common";


const PakingDetailSettlementPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [parkingStatistic, setParkingStatistic] = useState(null);
  const [loading, setLoading] = useState(0);
  const [chartData, setChartData] = useState({
    labels: ["입차", "출차"],
    datasets: [
      {
        data: [0, 0],
        backgroundColor: ["#68CDA4", " #29835F"],
        borderWidth: 0,
      },
    ],
  });
  const { user, serverTime } = useSelector((state) => state.auth);

  const { parkingName } = useSelector((state) => state.parking);
  const currentYear = getFormattedTime(serverTime, "yyyy");
  const currentMonth = getFormattedTime(serverTime, "MM");

  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(currentMonth);

  const startYear = 2024;
  const yearOptions = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  );
  const monthOptions = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0"));

  const getDataStatistics = async () => {

    try {
      const response = await getParkingStatistics({
        parkingId: user?.parkingId,
        timeSearch: `${year}${String(month).padStart(2, "0")}`,
      })
      setParkingStatistic(response);
      setChartData({
        ...chartData,
        datasets: [
          {
            ...chartData.datasets[0],
            data: [response?.data?.inCar || 0, response?.data?.outCar || 0],
          },
        ],
      })
      console.log({
        ...chartData,
        datasets: [
          {
            ...chartData.datasets[0],
            data: [response?.inCar, response?.outCar],
          },
        ],
      })
      console.log("Statistics Data:", response);
    } catch (error) {
      console.error("Error fetching statistics data:", error);
    } finally {
      setLoading(prev => prev + 1);
      dispatch(setAppLoading(false));
    }
  };

  useEffect(() => {
    return () => {
      setLoading(0);
    }
  }, []);

  useEffect(() => {
    loading >= 1 && dispatch(setAppLoading(true));
    getDataStatistics(year, month);
  }, [year, month]);

  const handleRowClick = () => {
    navigate("/schedule_setting");
  };

  const refreshFunction = () => {
    setLoading(0);
    getDataStatistics(year, month);
  }

  return (
    loading == 0 ?
      <PakingDetailSettlementPageSkeleton />
      :
      <AppInfiniteScroll
        data={[]}
        hasMore={false}
        refreshFunction={refreshFunction}
      >
        <div className="schedule-management-container">
          <SubHeader>
            <div className={`sub-header-text w-full`} >

              <span className="htColorGray2">주차장명 : </span>
              <span className="htBold">{user?.parking?.parkingName} ({user.parkingId})</span>

            </div>
          </SubHeader>
          <div className="htContent">
            <div className="mn-date-filter mt-15">
              <select className="mn-select-date" value={year} onChange={(e) => setYear(parseInt(e.target.value))}>
                {yearOptions.map((y) => (
                  <option key={y} value={y}>{y}년</option>
                ))}
              </select>
              <select className="mn-select-date" value={month} onChange={(e) => setMonth(e.target.value)}>
                {monthOptions.map((m) => (
                  <option key={m} value={m}>{m}월</option>
                ))}
              </select>
            </div>

            <div className="chart-container">
              {
                chartData.datasets[0].data[0] === 0 && chartData.datasets[0].data[1] === 0 ?
                  <div className="htStatisticNodata">입출차 데이터가 없습니다.</div> :
                  <Doughnut
                    data={chartData}
                    height={108}
                    width={108}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                      plugins: {
                        legend: { display: false },
                        tooltip: { enabled: false }
                      },
                    }}
                  />}

              <div className="custom-legend">
                <div className="legend-item left">
                  <span>입차: </span>
                  <strong>{chartData.datasets[0].data[0]}건</strong>
                </div>
                <div className="legend-item right">
                  <span>출차: </span>
                  <strong>{chartData.datasets[0].data[1]}건</strong>
                </div>
              </div>
            </div>

            <div className="summary-table">
              <div className="mn-summary-table-content">
                <span className="htBold">입출차 총계</span>
                <div className="flex-between">
                  <span>합계</span>
                  <span style={{ fontWeight: "700" }}>
                    {parkingStatistic?.data?.totalInOut || 0}건
                  </span>
                </div>
                <div className="flex-between"><span>입차건수</span><span style={{ fontWeight: "700" }}>{parkingStatistic?.data?.inCar || 0}건</span></div>
                <div className="flex-between"><span>출차건수</span><span style={{ fontWeight: "700" }}>{
                  parkingStatistic?.data?.outCar || 0}건</span></div>
              </div>
              <div className="mn-summary-table-content">
                <span className="htBold">카드승인 금액</span>
                <div className="flex-between"><span>건수</span><span style={{ fontWeight: "700" }}>
                  {
                    parkingStatistic?.data?.totalPay || 0
                  }건
                </span></div>
                <div className="flex-between"><span>금액</span><span style={{ fontWeight: "700" }}>{
                  numberFormat(parkingStatistic?.data?.totalPrice || 0)
                }원</span></div>
              </div>
              <div className="mn-summary-table-content">
                <span className="htBold">미납관리</span>
                <div className="flex-between"><span>건수</span><span style={{ fontWeight: "700" }}>{
                  parkingStatistic?.data?.totalNotPay || 0
                }건</span></div>
                <div className="flex-between"><span>금액</span><span style={{ fontWeight: "700" }}>{
                  numberFormat(parkingStatistic?.data?.totalNotPrice || 0)
                }원</span></div>
              </div>
            </div>

          </div>

        </div>
      </AppInfiniteScroll>
  );
};

export default PakingDetailSettlementPage;


const PakingDetailSettlementPageSkeleton = () => {
  return (
    <div
      style={{
        padding: '20px',
        backgroundColor: 'white',
        borderRadius: '8px',
      }}
    >
      <Skeleton height={40} width={"100%"} style={{ marginBottom: '20px' }} />

      <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
        <Skeleton width={100} height={40} />
        <Skeleton width={100} height={40} />
      </div>

      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <Skeleton circle={true} height={150} width={150} />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '10px',
            padding: '0 30px',
          }}
        >
        </div>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <Skeleton width={120} height={20} style={{ marginBottom: '10px' }} />
        <Skeleton width={180} height={20} style={{ marginBottom: '10px' }} />
        <Skeleton width={180} height={20} style={{ marginBottom: '10px' }} />
        <Skeleton width={180} height={20} style={{ marginBottom: '10px' }} />
      </div>

      <div style={{ marginBottom: '20px' }}>
        <Skeleton width={120} height={20} style={{ marginBottom: '10px' }} />
        <Skeleton width={100} height={20} style={{ marginBottom: '10px' }} />
        <Skeleton width={100} height={20} style={{ marginBottom: '10px' }} />
      </div>

      <div>
        <Skeleton width={120} height={20} style={{ marginBottom: '10px' }} />
        <Skeleton width={100} height={20} style={{ marginBottom: '10px' }} />
        <Skeleton width={100} height={20} style={{ marginBottom: '10px' }} />
      </div>
    </div>
  );
};

